import { AppearanceIncoming } from '~/data/appearance';
import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = (customAppearance?: AppearanceIncoming) => {
  // TODO Re-enable Topbar customAppearance & topBarColorSet when decided by management,
  //  use fixed customAppearance styling until then.
  const topBarColorSet = false;
  // customAppearance?.fTopBarColors &&
  // customAppearance?.fTopBarColors.fBackgroundColor !== '';

  const itemColors = topBarColorSet
    ? {
        color: customAppearance?.fTopBarColors.fIconsColor,
        backgroundColor: customAppearance?.fTopBarColors.fBackgroundColor,
        '&:hover': {
          backgroundColor: `${customAppearance?.fTopBarColors.fIconsColor}40`,
        },
      }
    : {
        color: legacyColors.blue2,
        '&:hover': {
          color: legacyColors.white,
          backgroundColor: legacyColors.blue3,
        },
      };

  return {
    loading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100vw',
      height: '100vh',
    },
    root: {
      overflowY: 'auto',
      width: '100vw',
      minWidth: '320px',
      height: '100%',
    },
    toolbar: {
      justifyContent: 'space-between',
      backgroundColor: topBarColorSet
        ? customAppearance?.fTopBarColors.fBackgroundColor
        : legacyColors.blue,
    },
    logoImage: {
      height: '30px',
      width: 'auto',
      maxWidth: '100%',
    },
    actions: {
      display: 'flex',
      justifyContent: 'right',
    },
    menuButton: {
      ...itemColors,
    },
    contentContainer: {},
    mainMenu: {
      display: 'grid',
      gridTemplateRows: `auto 1fr auto`,
      height: '100%',
    },
    mainMenuToggle: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 1),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
      justifyContent: 'flex-start',
    },
    mainMenuContent: {
      overflowY: 'auto',
    },
    pageFooterContainer: {
      top: 'auto',
      bottom: 0,
    },
    pageFooter: {
      padding: theme.spacing(1, 2),
      display: 'flex',
      justifyContent: 'center',
    },
    pageFooterLogo: {
      height: '15px',
      width: 'auto',
    },
  };
};
